import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AbstractAdvTechService} from '../abstract-advtech.service';

/**
 * Gets the images from Prism
 * @class ImageService
 * @extends AbstractAdvTechService
 * @description Defines the prefix to get images from Prism and a method to get resized image URLs
 */
@Injectable()
export class ImageService extends AbstractAdvTechService {
  /**
   * prefix for the image urls
   * @type {string}
   */
  protected prefix: string = 'content/image';

  /**
   * Gets the resize image url to be placed in the src
   * @param {string} id image id
   * @param {number} height image height
   * @param {number} width image width
   * @param {string} resize image resize
   * @returns {string}
   */
  buildResizedImageUrl(id: string,
    height: number,
    width: number,
    resize: string = '80x60!') {
    const crop = `${width}x${height}+0+0`;

    return `${this.hubUrl}/${this.prefix}/redirect/${id}/crop/${crop}/resize/${resize}?${Date().toString()}`;
  }

  /**
   * Gets the basic url for the image
   * @param {string} id
   * @returns {string}
   */
  buildImageUrl(id: string) {
    return `${this.hubUrl}/${this.prefix}/redirect/${id}`;
  }

  getImageData(id: string, skipLoading: boolean = false): Observable<any> {
    this.setLoadingMessage('Retrieving Image');
    return this.callGetEndpoint(`api/content/image/${id}`, skipLoading, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/advtech/image/image.service.ts